// Keep transport details separate from the message shown to a customer.
export function voiceErrorDetails(error = {}) {
  const code = error.code || '';
  if (code === 'voice_command_mode_unavailable') return {title:'Spoken replies off is not available yet',message:'Turn spoken replies on below to use voice, or try again after the website updates.',retryAt:null,code};
  const legacyLimit = /(?:today.s .*limit|voice spending allowance).*reached/i.test(error.message || '');
  const limited = error.status === 429 || legacyLimit;
  const retryAt = Number.isFinite(error.retryAt) ? error.retryAt : null;
  if (limited) {
    const messages = {
      voice_visitor_daily_limit: 'You’ve reached today’s voice limit for this browser.',
      voice_network_daily_limit: 'Voice has reached today’s limit for this internet connection.',
      voice_site_daily_limit: 'Voice has reached today’s limit for this website.',
      voice_budget_daily_limit: 'This website’s daily voice allowance has been reached.',
      voice_budget_monthly_limit: 'This website’s monthly voice allowance has been reached.',
      voice_provider_limit: 'The voice service is temporarily busy.'
    };
    return {title:code === 'voice_provider_limit' ? 'Voice is temporarily busy' : 'Voice limit reached',
      message:messages[code] || 'Voice is temporarily limited. Please try again later.',
      retryAt, resets: /(?:daily|monthly)_limit$/.test(code), code, status:429};
  }
  if (error.name === 'NotAllowedError') return {title:'Microphone access is blocked',message:'Allow microphone access in your browser settings, then try voice again.',retryAt:null};
  if (error.status === 401) return {title:'Your voice session expired',message:'Try voice again to reconnect to your conversation.',retryAt};
  if (error.status === 403) return {title:'Voice is unavailable here',message:'Voice access is unavailable for this website right now.',retryAt};
  return {title:'Voice couldn’t connect',message:'Please check your connection and try again.',retryAt};
}

export function voiceRetryMessage(failure, now = Date.now()) {
  if (!Number.isFinite(failure?.retryAt)) return '';
  if (failure.retryAt <= now) return 'You can try voice again now.';
  const time = new Intl.DateTimeFormat(undefined,{month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(failure.retryAt);
  return `${failure.resets ? 'This limit resets' : 'You can try again'} on ${time}.`;
}
